<template>
    <master-layout>
        <div class="breadcamb_box">
            <div>
                <h4 class="page-title"><i class="ti-location-arrow"></i> {{ $t('massive_emails') }} <label class="label label-warning m-r-5 m-b-0">Beta</label></h4> 
            </div>
            <pml-back-button></pml-back-button>
        </div>
        <PmlFilter></PmlFilter>
        <div class="row">
            <div class="col-md-12">
                <PmlList></PmlList>
            </div>
        </div>
    </master-layout>
</template>

<script>
    import bus from 'utils/events/bus'
    import { trans } from 'utils/helpers/translation'
    import PmlFilter from './Filter.vue'
    import PmlList from './List.vue'

    export default {
        name: 'Emails',
        metaInfo () {
            return {
                title: trans('emails')
            }
        },
        components: { PmlFilter, PmlList },
        mounted () {
            bus.$emit('doFilterEmails', 1)
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/emails/massive/components/Main.vue